export const AVERAGE_DUMPSTER_DIMENSIONS = {
  length: 22,
  width: 7.5,
  height: 6,
}; 